import { FC } from 'react';

import { FormControl } from '@mui/material';
import { FieldProps } from 'formik';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';

interface FormikInputFieldProps extends FieldProps {
  label: string;
  required?: boolean;
}

export const FormikInputField: FC<FormikInputFieldProps> = ({
  field,
  form,
  label,
  required = false,
}) => {
  const { name, value, onBlur, onChange } = field;
  const { touched, errors } = form;

  return (
    <FormControl>
      <BaseFormInputField
        id={name}
        label={label}
        name={name}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        error={touched[name] && !!errors[name]}
        helperText={touched[name] && errors[name] ? String(errors[name]) : ''}
        InputLabelProps={{ required }}
      />
    </FormControl>
  );
};
